import React, {useState} from "react";
import {Box, Typography, Button} from "@mui/material";
import {Link, useLocation} from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import {Logout, PersonPinCircleOutlined} from "@mui/icons-material";
import GavelIcon from '@mui/icons-material/Gavel';
import {GridMenuIcon} from "@mui/x-data-grid";
import {getUserInfo} from "../../helpers/user";

const adminNavLinks = [
    {
        title: "Home",
        path: "/",
        icon: HomeIcon,
    },
    {
        title: "Sensors",
        path: "/sensors",
        icon: WarningAmberIcon,
    },
    {
        title: "Alerts",
        path: "/alerts",
        icon: WarningAmberIcon,
    },
    {
        title: "Riskmap",
        path: "/riskmap",
        icon: AltRouteIcon,
    },
    {
        title: "Rules",
        path: "/rules",
        icon: GavelIcon,
    },
    {
        title: "Users",
        path: "/users",
        icon: PersonPinCircleOutlined,
    },
];

const userNavLinks = [
    {
        title: "Home",
        path: "/",
        icon: HomeIcon,
    },
    {
        title: "Sensors",
        path: "/sensors",
        icon: WarningAmberIcon,
    },
    {
        title: "Alerts",
        path: "/alerts",
        icon: WarningAmberIcon,
    },
];

const Sidebar = () => {
    const {pathname} = useLocation();
    const userInfo = getUserInfo();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const navLinks =
        userInfo.role === "admin" || userInfo.role == "org_admin"
            ? adminNavLinks
            : userNavLinks;

    return (
        <>
            <Box
                sx={{
                    backgroundColor: "#161d2f",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                }}
            >
                <Button
                    onClick={toggleMobileMenu}
                    sx={{
                        display: {sm: "block", md: "block", lg: "none"},
                        color: "white",
                        justifyContent: "flex-start",
                        ":hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                    }}
                >
                    <GridMenuIcon sx={{fontSize: 30}}/>
                </Button>
                <Box
                    sx={{
                        display: {
                            xs: isMobileMenuOpen ? "block" : "none",
                            sm: isMobileMenuOpen ? "block" : "none",
                            md: isMobileMenuOpen ? "block" : "none",
                            lg: "block",
                        },
                        flexDirection: "column",
                        width: "100%",
                    }}
                >
                    {/* User Info */}
                    <Typography sx={{color: "white", padding: 2, pb: 0}}>
                        {userInfo.name}
                        <br/>
                    </Typography>

                    <Typography
                        sx={{color: "white", pt: 0, padding: 2, pb: 3, fontWeight: 800}}
                    >
                        {userInfo.organization}
                    </Typography>
                    <Box
                        sx={{
                            backgroundColor: "#1f2940",
                        }}
                    >
                        {navLinks.map((item) => (
                            <Box
                                key={item.title}
                                sx={{
                                    width: "100%",
                                    border: 1,
                                    borderColor: "divider",
                                    borderRadius: 0,
                                    backgroundColor:
                                        pathname === item.path ? "secondary.main" : "transparent",
                                    py: 1,
                                    ":hover": {
                                        backgroundColor: "secondary.main",
                                    },
                                }}
                            >
                                <Link to={item.path} style={{textDecoration: "none"}}>
                                    <Typography
                                        sx={{
                                            color: "grey.300",
                                            fontWeight: pathname === item.path ? "900" : "600",
                                            padding: 1,
                                            pl: 2,
                                            pr: 3,
                                            display: "block",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                </Link>
                            </Box>
                        ))}
                    </Box>

                    <Link to={"/logout"} style={{textDecoration: "none"}}>
                        <Box
                            sx={{
                                display: "inline-flex",
                                px: 2,
                                pt: 4,
                                pb: 2,
                                color: "white",
                                ":hover": {
                                    color: "#bbbbbb",
                                },
                            }}
                        >
                            <Logout/> <Typography>Logout </Typography>
                        </Box>
                    </Link>
                </Box>
            </Box>
        </>
    );
};

export default Sidebar;
